import React from 'react';
import Select from 'react-select';

export default class SelectReturnResolution extends React.Component {
  constructor(props) {
    super(props);

    this.options = [
      { value: 'RMA', label: 'Devolución del dinero al cliente (RMA)' },
      { value: 'RPL', label: 'Reposición de productos (RPL)' },
      { value: 'SAR', label: 'Sin acción requerida' },
    ];
  }

  onChangeWrapper(value) {
    let event = { target: {} };
    event.target.name = this.props.name ? this.props.name : 'select-nameless';
    event.target.value = value ? value.value : null;
    event.target.type = 'react-select';
    this.props.onChange(event);
  }
  render() {
    let value = this.props.value;

    if (value) {
      value = this.options.find(option => option.value === value);
    }

    return (
      <Select
        className={this.props.selectClassName}
        name={this.props.name}
        onChange={this.onChangeWrapper.bind(this)}
        value={value || ''}
        options={this.options}
        placeholder={this.props.placeholder}
        isDisabled={this.props.disabled}
        menuContainerStyle={{ zIndex: 999 }}
      />
    );
  }
}
